<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">
        {{ $t('tradeIn.serailList') }}
      </h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <div class="ts-mt-3 max-h ts-rounded ts-overflow-y-scroll">
        <table class="ts-w-full">
          <thead>
            <tr>
              <th
                class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 "
                style="width: 14%"
              >
                {{ $t('tradeIn.serial') }}
              </th>
              <th class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3">
                {{ $t('tradeIn.grade') }}
              </th>
              <th class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3">
                {{ $t('tradeIn.imeiVin') }}
              </th>
              <th class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3">
                {{ $t('tradeIn.engineNumber') }}
              </th>
              <th
                class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                style="width: 9%"
              >
                {{ $t('tradeIn.status') }}
              </th>
              <th
                class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                style="width: 9%"
                v-if="value !== undefined"
              ></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(serial, index) in serialResource" :key="index">
              <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                {{ serial.serial_no }}
              </td>
              <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap text-center">
                {{ serial.product_grade }}
              </td>
              <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                {{ serial.imei }}
              </td>
              <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                {{ serial.engine_number }}
              </td>
              <td
                class="ts-py-1 ts-px-3 text-center ts-whitespace-no-wrap ts-font-bold"
              >
                <span
                  :class="'text-' + serialStatusStyle(serial.sn_status_id)"
                  >{{ serial.sn_status }}</span
                >
              </td>
              <td
                class="ts-py-1 ts-px-3 text-center ts-whitespace-no-wrap ts-font-bold"
                v-if="value !== undefined"
              >
                <a
                  href="#"
                  class="ts-text-red-600 ts-my-auto"
                  @click.prevent="removeSerial(serial)"
                >
                  <i class="fa fa-trash"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="ts-mt-1 ts-mr-2 ts-text-right ts-font-bold text-danger">
        TOTAL : {{ serialResource.length }}
      </div>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
export default {
  name: 'showSerial',
  props: ['value', 'data'],
  data() {
    return {
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    serialResource() {
      return this.data.serial_list
    },
    serialStatusStyle: () => sn_status_id => {
      let value = ''

      switch (sn_status_id) {
        case 1:
          value = 'primary'
          break
        case 2:
          value = 'warning'
          break
        case 3:
          value = 'success'
          break
        case 4:
          value = 'info'
          break
        case 5:
          value = 'pink'
          break
        case 6:
          value = 'danger'
          break
      }

      return value
    }
  },
  methods: {
    removeSerial(serial) {
      // Loop through product_details to find the serial
      this.model.product_details.forEach((item, index) => {
        const serialIndex = item.serial_list.findIndex(
          s => s.serial_no === serial.serial_no
        )
        // If the serial is found, remove it
        if (serialIndex !== -1) {
          item.serial_list.splice(serialIndex, 1)

          // Update quantity
          item.quantity = item.serial_list.length

          // If no serials are left, remove the whole item
          if (item.serial_list.length === 0) {
            this.model.product_details.splice(index, 1)
          }
        }
      })
    }
  }
}
</script>
<style scoped>
table > thead > tr > th,
table > tbody > tr > td {
  padding: 3px 5px;
}
.table > thead > tr > th {
  position: sticky;
  top: 0;
  z-index: 10;
}
.max-h {
  max-height: 50vh;
}
</style>
